import type { MenuResponse, RecipeGridContentBlock } from '@library/api-menu-experience'
import type { CollectionUUID } from '@library/menu-service'

import { useStaticArray } from 'hooks/useStaticArray'
import { useTrackRecipeListEffect } from 'routes/Menu/MenuRecipesPage/RecipeList/useTrackRecipeListEffect'
import { useTrackSoldOutRecipesEffect } from 'routes/Menu/MenuRecipesPage/RecipeList/useTrackSoldOutRecipesEffect'

const getRecipeGrid = (content: MenuResponse['content']) =>
  content.find(({ type }) => type === 'recipe-grid') as RecipeGridContentBlock | undefined

export const useMenuExperienceRecipeListTracking = (data: MenuResponse) => {
  const recipeGrid = getRecipeGrid(data.content)
  const recipes = useStaticArray(
    recipeGrid?.items ?? [],
    (currentRecipe, nextRecipe) =>
      currentRecipe.id === nextRecipe.id && currentRecipe.isAvailable === nextRecipe.isAvailable,
  )
  const recipeIds = useStaticArray(recipes.map(({ id }) => id))

  useTrackSoldOutRecipesEffect(recipes)
  useTrackRecipeListEffect(data.categoryId as CollectionUUID, recipeIds)
}
